<template>
    <div class="site-flex">
        <transition name="slide-td">
            <navbar v-if="isLoggedIn" ref="navbar"></navbar>
        </transition>
        <b-notification v-for="(message, index) in $store.state.messages" :key="index"
                        :type="'is-' + message.type" v-on:close="$store.commit('removeMessage', index)"
                        has-icon aria-close-label="Close message">
            {{ message.text }}
        </b-notification>
<!--        The navbar seems to want to overlap the margin of the item below it.-->
<!--        This makes transitions ugly in Firefox.-->
        <router-view class="full-height" style="margin-top: 0;"></router-view>
        <heat-footer></heat-footer>
        <vue-cookie-accept-decline
            v-if="inEU()"
            :elementId="'heat-tracking'"
            :debug="false"
            :position="'bottom-right'"
            :type="'floating'"
            :transitionName="'slideFromBottom'"
            @clicked-accept="cookieClickedAccept">
            <div slot="declineContent" class="has-text-danger">
               Opt out
            </div>
            <div slot="acceptContent" class="has-text-info">
                I Accept
            </div>
        </vue-cookie-accept-decline>
    </div>
</template>

<script>
    import inEU from '@segment/in-eu'
    import {mapGetters} from "vuex";
    import Navbar from "./components/Navbar";
    import BNotification from "buefy/src/components/notification/Notification";
    import VueCookieAcceptDecline from 'vue-cookie-accept-decline/src/vue-cookie-accept-decline'
    import HeatFooter from "heat-shared/src/components/HeatFooter";
    import urls from "./urls";

    export default {
        name: "App",
        components: {HeatFooter, BNotification, Navbar, VueCookieAcceptDecline},
        mixins: [urls],
        computed: {
            ...mapGetters('user', [
                'isLoggedIn',
            ]),
        },
        methods: {
            cookieClickedAccept() {
                this.$gtag.enable();
                this.$gtag.page(this.$router);
            },
            inEU(){
                return inEU();
            }
        }
    }
</script>

<style scoped>

</style>